import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

function PageTitle() {
  const location = useLocation();
  const pathname = location.pathname;
  
  // Default title and descriptions with corrected service order
  let title = "GuardiansMoves - Sicherheitsdienste, Taxi & Reinigung in Berlin";
  let description = "GuardiansMoves ist Ihr zuverlässiger Partner für professionelle Sicherheitsdienste, Taxi- und Mietwagenservice und Reinigung in Berlin. 24/7 für Sie da!";
  let keywords = "GuardiansMoves, Sicherheitsdienste Berlin, Security Berlin, Taxi Berlin, Mietwagenservice Berlin, Reinigungsservice Berlin";
  
  // Set specific titles based on route
  if (pathname.includes('sicherheit')) {
    title = "Professionelle Sicherheitsdienste in Berlin | GuardiansMoves";
    description = "Zertifizierter Sicherheitsdienstleister nach §34a - Wir bieten professionelle Sicherheitskonzepte für Veranstaltungen, Objekte und Kontrolldienste in Berlin.";
    keywords = "Sicherheitsdienst Berlin, Security Berlin, Veranstaltungssicherheit, Objektschutz Berlin";
  } else if (pathname.includes('taxi')) {
    title = "Taxi & Mietwagenservice Berlin | GuardiansMoves";
    description = "Unser Taxi & Mietwagenservice in Berlin bringt Sie pünktlich und sicher ans Ziel. Flughafentransfer, Chauffeurservice und mehr - 365 Tage im Jahr für Sie verfügbar.";
    keywords = "Taxi Berlin, Mietwagenservice Berlin, Flughafentransfer Berlin, Chauffeurservice Berlin";
  } else if (pathname.includes('reinigung')) {
    title = "Professionelle Reinigungsservice in Berlin | GuardiansMoves";
    description = "Unsere Reinigungsdienste kümmern sich um private und gewerbliche Immobilien in Berlin - von regelmäßiger Unterhaltsreinigung bis zu Hausmeisterdiensten.";
    keywords = "Reinigungsservice Berlin, Gebäudereinigung Berlin, Unterhaltsreinigung, Hausmeisterdienste Berlin";
  } else if (pathname.includes('jobs')) {
    title = "Karriere & Jobs in Berlin | GuardiansMoves";
    description = "Starten Sie Ihre Karriere bei GuardiansMoves. Wir suchen engagierte Mitarbeiter für unsere Bereiche Sicherheit, Taxi und Reinigung in Berlin.";
    keywords = "Jobs Berlin, Karriere Sicherheitsdienst, Taxi Fahrer Jobs, Reinigungskraft Berlin";
  } else if (pathname.includes('impressum')) {
    title = "Impressum | GuardiansMoves Berlin";
    description = "Impressum von GuardiansMoves - Ihr zuverlässiger Partner für Sicherheit, Taxi und Reinigung in Berlin.";
  } else if (pathname.includes('datenschutz')) {
    title = "Datenschutzerklärung | GuardiansMoves Berlin";
    description = "Datenschutzerklärung von GuardiansMoves - Erfahren Sie wie wir Ihre Daten schützen.";
  }
  
  // Canonical URL
  const baseUrl = "https://guardiansmoves.de";
  const canonicalPath = pathname.endsWith('.html') 
    ? pathname.replace('.html', '') 
    : pathname;
  const canonicalUrl = `${baseUrl}${canonicalPath}`;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="GuardiansMoves" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://guardiansmoves.de/logo512.png" />
      <meta property="og:site_name" content="GuardiansMoves" />
      <meta property="og:locale" content="de_DE" />
      
      {/* Twitter Card data */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="https://guardiansmoves.de/logo512.png" />
      
      {/* Geo tags for local business */}
      <meta name="geo.region" content="DE-BE" />
      <meta name="geo.placename" content="Berlin" />
      
      {/* Additional SEO-friendly meta tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="German" />
      <meta name="revisit-after" content="7 days" />
    </Helmet>
  );
}

export default PageTitle;